/**
 * Единая точка управления путями навигации.
 * Все переходы (navigate, Link to, href для роутов) должны использовать только эти константы.
 */

const CABINET = '/cabinet';
const ROOT = '/';
const LOGIN = '/login';
const ROBO = '/robo';
const QUIZ = '/quiz';
const AGREEMENT = '/agreement';
const POLICY = '/policy';
const ROBOVISOR_LANDING = '/roboadvisor';

// ——— Cabinet (все пути относительно /cabinet) ———
const accounting = {
  dashboard: `${CABINET}/accounting/dashboard`,
  balance: `${CABINET}/accounting/balance`,
  dynamic: `${CABINET}/accounting/dynamic`,
  values: `${CABINET}/accounting/values`,
  accountsPropertiesObligations: `${CABINET}/accounting/accounts-properties-obligations`,
  logs: `${CABINET}/accounting/logs`,
  clients: `${CABINET}/accounting/clients`,
};

const roboadvisor = {
  index: `${CABINET}/roboadvisor`,
  detail: (roboId) => `${CABINET}/roboadvisor/${roboId}`,
  transactions: (params = '') => `${CABINET}/roboadvisor/transactions${params ? `?${params}` : ''}`,
};

const plan = {
  plan: `${CABINET}/plan/plan`,
  salaryPlan: `${CABINET}/plan/salary-plan`,
  goals: `${CABINET}/plan/goals`,
  insurances: `${CABINET}/plan/insurances`,
};

const register = {
  page1: `${CABINET}/register/page1`,
};

const incomeAndExpenses = {
  tactics: `${CABINET}/income-and-expenses/tactics`,
  income: `${CABINET}/income-and-expenses/income`,
  spendings: `${CABINET}/income-and-expenses/spendings`,
};

const investing = {
  case: `${CABINET}/investing/case`,
  invest: `${CABINET}/investing/invest`,
  archiveInvest: `${CABINET}/investing/archive-invest`,
  repos: `${CABINET}/investing/repos`,
  reposClosed: `${CABINET}/investing/repos/closed`,
  diagrams: `${CABINET}/investing/diagrams`,
  diagramView: (id) => `${CABINET}/investing/diagrams/view/${id}`,
  chart: (params = '') => `${CABINET}/investing/chart${params ? `?${params}` : ''}`,
  paymentsCalendar: `${CABINET}/investing/payments-calendar`,
};

const config = {
  index: `${CABINET}/config`,
  /** URL с возвратом: routes.config.withBack(routes.incomeAndExpenses.spendings) */
  withBack: (backPath) => `${CABINET}/config?back=${encodeURIComponent(backPath)}`,
  hash: (hash) => `${CABINET}/config#${hash}`,
};

const common = {
  config: config.index,
  quizes: `${CABINET}/quizes`,
  notifications: `${CABINET}/notifications`,
  error: `${CABINET}/error`,
  ui: `${CABINET}/ui`,
  test: `${CABINET}/test`,
};

/** Проверка: путь под кабинетом */
const isCabinetPath = (pathname) => pathname.startsWith(CABINET);

/** Массивы для проверки "активного" пункта меню (включая вложенные) */
const accountingValidPaths = [
  CABINET,
  accounting.accountsPropertiesObligations,
  accounting.dashboard,
  accounting.balance,
  accounting.dynamic,
  accounting.values,
  accounting.logs,
  roboadvisor.index,
];
const incomeAndExpensesValidPaths = [
  incomeAndExpenses.income,
  incomeAndExpenses.spendings,
  incomeAndExpenses.tactics,
];
const planValidPaths = [plan.plan, plan.salaryPlan, plan.goals, plan.insurances];
const investingValidPaths = [
  investing.case,
  investing.invest,
  investing.archiveInvest,
  investing.repos,
  investing.reposClosed,
  investing.diagrams,
  investing.chart(),
  investing.paymentsCalendar,
  roboadvisor.index,
];

/** Путь для обучения (TeachDropdown) */
const TRAINING_PAGE_URL = register.page1;

export const routes = {
  ROOT,
  LOGIN,
  CABINET,
  ROBO,
  QUIZ,
  AGREEMENT,
  POLICY,
  ROBOVISOR_LANDING,

  accounting,
  roboadvisor,
  plan,
  register,
  incomeAndExpenses,
  investing,
  config,
  common,

  isCabinetPath,

  accountingValidPaths,
  incomeAndExpensesValidPaths,
  planValidPaths,
  investingValidPaths,

  TRAINING_PAGE_URL,
};

/** Для auth reducer и проверок логина */
export const URL_LOGIN = [LOGIN, '/en/login', '/ru/login'];
export const URL_SUBSCRIBE = ROBOVISOR_LANDING;

export default routes;
